import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeeItemFormValues, FeeItem } from '../../types';
import { feesApi } from '../services';

export interface FeeFormState {
  formValues?: FeeItemFormValues;
}

const initialState: FeeFormState = {};

export const feeFormSlice = createSlice({
  name: 'feeForm',
  initialState,
  reducers: {
    clearFeeFormState: (state) => {
      state.formValues = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      feesApi.endpoints.getFeeItem.matchFulfilled,
      (state, action: PayloadAction<{ data: FeeItem }>) => {
        const { data } = action.payload;

        if (data) {
          const formValues: FeeItemFormValues = {
            name: data.name,
            feeType: data.feeType,
          };

          if (data?.feeTransactionType) {
            formValues.feeTransactionType = data.feeTransactionType;
          }

          if (data?.regularFeeSubType) {
            formValues.regularFeeSubType = data.regularFeeSubType;
          }

          if (data?.regularFeePeriod) {
            formValues.regularFeePeriod = data.regularFeePeriod;
          }

          if (data?.regularHighBalanceAmount) {
            formValues.regularHighBalanceAmount =
              data.regularHighBalanceAmount?.toString();
          }

          if (data?.feeTargetAccountNumber) {
            formValues.feeTargetAccountNumber = data.feeTargetAccountNumber;
          }

          if (data?.regularInactivityMonthsAmount) {
            formValues.regularInactivityMonthsAmount =
              data.regularInactivityMonthsAmount;
          }

          if (data?.paymentType) {
            formValues.paymentType = data.paymentType;
          }

          state.formValues = formValues;
        }
      },
    );
  },
});

export const { clearFeeFormState } = feeFormSlice.actions;

export default feeFormSlice.reducer;
